// Muski character data, mood config, and generated mood art.
export const MUSKI_IMAGES = {
  Calm: "https://static.prod-images.emergentagent.com/jobs/2a62b53a-29b6-4207-a083-e9be0c4f9b0a/images/7dddee9a6875462828eb77bb28d509e40f877bd09b665b0ce92658d2912d8a00.jpeg",
  Curious: "https://static.prod-images.emergentagent.com/jobs/2a62b53a-29b6-4207-a083-e9be0c4f9b0a/images/99f5ff270e933159029cdc52b18bde3a8d9d6c643620f643ffab282d54685232.jpeg",
  Ambush: "https://static.prod-images.emergentagent.com/jobs/2a62b53a-29b6-4207-a083-e9be0c4f9b0a/images/fdbc9ea63d71a87e142fbb8c7fa4497cce090f482b9d1174c6091cfbf7caaf76.jpeg",
  Zoomies: "https://static.prod-images.emergentagent.com/jobs/2a62b53a-29b6-4207-a083-e9be0c4f9b0a/images/9cc0f7c43eba8ed7cb2c74750e0062099cdd0bf44f2acab673e333f285e8a653.jpeg",
};

export const MOODS = {
  Calm: {
    label: "Calm",
    tagline: "Pretending she's chill.",
    primary: "#38BDF8",
    glow: "rgba(56,189,248,0.22)",
    badge: "bg-sky-950/70 text-sky-300 border-sky-500/40",
    ring: "shadow-[0_0_60px_-10px_rgba(56,189,248,0.6)]",
  },
  Curious: {
    label: "Curious",
    tagline: "Ears up. Something moved.",
    primary: "#F59E0B",
    glow: "rgba(245,158,11,0.22)",
    badge: "bg-amber-950/70 text-amber-300 border-amber-500/40",
    ring: "shadow-[0_0_60px_-10px_rgba(245,158,11,0.6)]",
  },
  Ambush: {
    label: "Ambush",
    tagline: "Under the rug. Do NOT trust the stillness.",
    primary: "#EC4899",
    glow: "rgba(236,72,153,0.26)",
    badge: "bg-pink-950/70 text-pink-300 border-pink-500/40",
    ring: "shadow-[0_0_60px_-10px_rgba(236,72,153,0.6)]",
  },
  Zoomies: {
    label: "Zoomies",
    tagline: "Pure chaos. Mach 10 goblin.",
    primary: "#A855F7",
    glow: "rgba(168,85,247,0.26)",
    badge: "bg-purple-950/70 text-purple-300 border-purple-500/40",
    ring: "shadow-[0_0_60px_-10px_rgba(168,85,247,0.6)]",
  },
};

export const MOOD_ORDER = ["Calm", "Curious", "Ambush", "Zoomies"];

export const WIN_AMBUSHES = 3;
export const WIN_AFFECTION = 100;
